import {EntityLinkedToAccountWithAuditMetadata} from '../../../../../common/entity/entityLinkedToAccountWithAuditMetadata';
import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {
   OnlineFormFormDefinitionSummaryModel
} from "../../../../../online-form/definition/api/entity/onlineFormFormDefinitionSummary.model";
import {AgendaCategorySummaryModel} from "./agendaCategorySummary.model";

export class AgendaCategory extends EntityLinkedToAccountWithAuditMetadata{

   summary: AgendaCategorySummaryModel;
   duration: number;
   visible: boolean;
   type: LovValueSummary;
   active: boolean;
   expectedTurnover: number;
   onlineBookingDisplayedPrice: number;
   onlineBookingDescriptionNewPartner: string;
   onlineBookingDescriptionExistingPartner: string;
   onlineFormDefinition: OnlineFormFormDefinitionSummaryModel;
   onlineBookingInstructions: string;
   onlineBookingCancellationConditions: string;
   onlineBookingDisplayDuration: boolean;
}
